module.exports = __webpack_public_path__ + "static/media/kocka3HRF.dc983425.png";